// ============================================
// useIsMobile — viewport + UA mobile detection
// ============================================
// Extracted from VoiceBotPanel.tsx in Wave 6a of the widget refactor.
//
// Returns true when:
//   - window.innerWidth < 768, OR
//   - navigator.userAgent matches a known mobile pattern.
//
// Re-evaluates on window resize. SSR-safe: returns false on first render
// when window is undefined (mirrors original useState(false) default).

import { useEffect, useState } from 'react'

const MOBILE_UA_PATTERN = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
const MOBILE_BREAKPOINT_PX = 768

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const isMobileWidth = window.innerWidth < MOBILE_BREAKPOINT_PX
      const isMobileUA = MOBILE_UA_PATTERN.test(navigator.userAgent)
      setIsMobile(isMobileWidth || isMobileUA)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return isMobile
}
